<template>
  <v-app-bar
    app
    dark
    class="header-container">
    <div v-if="isLoggedIn" class="header">

      <div class="left-buttons" >
          <v-img
          :src="logo"
          class="logo"
          ></v-img>
          <div
          class="d-flex align-center header-title">
            {{ $t('NRCKI') }}
          </div>

      </div>

      <div class="d-flex " style="height:40px; margin-top:10px;"  v-if=" this.$router.app._route.name === 'moderator-tab-2' || this.$router.app._route.name === 'moderator-council'">
        <h1 class="switch__current-lang"  x-snall style="color:rgba(255, 255, 255, 0.7); margin-top:-2.9px;">Заявки</h1>
        <v-switch  style="color:white;" v-model="is_council_page" label="Советы"></v-switch>
      </div>

      <template v-else>

        <div class="middle-buttons" v-if="GETTERS_HAVE_ROLE('kisi_user')">
          <KisiStatus></KisiStatus>
        </div>
      </template>

          <!--v-switch :color="$mainColor" class='hidden' v-model="changeLanguage" :label="GETTERS_APP_LANGUAGE"></v-switch-->
      <div class="right-buttons">

        <v-img
          v-if="GETTERS_AVATAR !== null"
          :src="GETTERS_AVATAR"
          height="30"
          width="30"
          class="grey darken-4 icon"
        ></v-img>
        <div>
        </div>
        <div class="my-2">
          <v-skeleton-loader
            height="50"
            class="text-header">
            {{GETTERS_NAME_USER.length !== 0 ? GETTERS_NAME_USER : 'Без имени'}}
          </v-skeleton-loader>
        </div>
        <v-menu
          bottom
          left>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              color="#fff"
              v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              class="item-menu-text"
              x-small
              v-if="GETTERS_HAVE_ROLE('moderator')"
              @click="goToPage('moderator-2')">
              <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-account-star</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{$t('header.moderator_interface')}}</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="item-menu-text"
              x-small
              v-if="GETTERS_HAVE_ROLE('expert')"
              @click="goToPage('expert-grid')">
              <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-card-account-details</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{$t('header.expert_interface')}}</v-list-item-title>
            </v-list-item>

            <v-list-item
              class="item-menu-text"
              x-small
              v-if="GETTERS_HAVE_ROLE('user_administrator') || GETTERS_HAVE_ROLE('moderator')"
              @click="goToPage('passes')">
              <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-passport</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{$t('header.passes')}}</v-list-item-title>
            </v-list-item>

            <v-list-item
              class="item-menu-text"
              x-small
              v-if="GETTERS_HAVE_ROLE('invite_administrator') || GETTERS_HAVE_ROLE('moderator')"
              @click="goToPage('invitations')">
              <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-ticket-account</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{$t('header.invitations')}}</v-list-item-title>
            </v-list-item>

            <v-list-item v-if="stations_count_big" class="item-menu-text" x-small>
              <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-account-box-multiple</v-icon>
              </v-list-item-action>
              <v-list-item-title>
                <v-menu bottom left >
                  <template v-slot:activator="{ on }">
                      <v-list-item-title v-on="on">Станции</v-list-item-title>
                  </template>
                  <v-list>
                    <template v-for="(item) in station">
                      <v-list-item
                        :key="item.id"
                        class="item-menu-text"
                        x-small
                        v-if="GETTERS_HAVE_ROLE('bs')"
                        @click="goToPage('bs', item.id)">
                        <v-list-item-action>
                          <v-icon :color="$mainColor" >mdi-account-box-multiple</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>{{item.name}}</v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu>
              </v-list-item-title>
            </v-list-item>  
          
            <template v-else v-for="(item) in station">
              <v-list-item
                :key="item.id"
                class="item-menu-text"
                x-small
                v-if="GETTERS_HAVE_ROLE('bs')"
                @click="goToPage('bs', item.id)">
                <v-list-item-action>
                  <v-icon :color="$mainColor" >mdi-account-box-multiple</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{item.name}}</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              class="item-menu-text"
              x-small
              @click="goToPage('synchrotron_calendar')">
              <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-calendar-range</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{$t('header.synchrotron_calendar')}}</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="item-menu-text"
              x-small
              @click="goToPage('reactor_calendar')">
              <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-calendar-range</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{$t('header.reactor_calendar')}}</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="item-menu-text"
              v-if="GETTERS_HAVE_ROLE('moderator') || GETTERS_HAVE_ROLE('ref_moderator')"
              x-small
              @click="goToPage('references')">
              <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-library</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{$t('header.references')}}</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="item-menu-text"
              v-if="GETTERS_HAVE_ROLE('moderator')"
              x-small
              @click="goToPage('users')">
              <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-account-group</v-icon>
              </v-list-item-action>
              <v-list-item-title>Пользоватети</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="item-menu-text"
              x-small
              v-if="GETTERS_HAVE_ROLE('moderator')"
              @click="goToPage('dashboard')">
              <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-chart-bar</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{$t('header.dashboard')}}</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="item-menu-text"
              small
              v-for="(item, i) in $t('menu_list')"
              :key="'main_menu_'+i"
              @click="goToPage(item.slug)">
               <v-list-item-action>
                <v-icon :color="$mainColor" >{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <notification-badge />
        <template v-if="$route.name !== null">
            <moderator-search/>
        </template>
      </div>
    </div>
    <div class="header" v-else>
      <div class="left-buttons">
        <v-img
          :src="logo"
          class="logo"
        ></v-img>
        <div class="d-flex align-center header-title">
          {{ $t('NRCKI') }}
        </div>
       <!--div class="switch ">
         <v-switch :color="$mainColor" v-model="changeLanguage" class="hidden" :label="GETTERS_APP_LANGUAGE"></v-switch>
       </div-->
      </div>
      <div
       v-if="$route.name !== 'Login'"
       class="right-buttons">
          <v-btn depressed small :color="$mainColor"
           @click="login">{{ $t('login.login') }}</v-btn>
      </div>
    </div>
    <v-spacer></v-spacer>

  </v-app-bar>
</template>

<script>

import user from '../../assets/user.png';
import logo from '../../assets/ustoc.png';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import NotificationBadge from './notificationBadge'
import ModeratorSearch from './moderator-search/moderatorSearch.vue'
import KisiStatus from './KisiStatus.vue'

export default {
  name: 'Header',
  components: {
    NotificationBadge,
    ModeratorSearch,
    KisiStatus,
  },
  data() {
    return {
      logo,
      avatar: user,
      firstname: '...',
      lastname: '...',
      loading: true,
      changeLanguage: 'ru',
      notAuthorizationItems: [
        { title: 'Войти' },
      ],
      nameUrlPath: '',
      station: [],
      stations_count_big: false,
      is_council_page: false,
    }
  },

  mounted() {
    this.nameUrlPath = this.$route.name
    this.changeLanguage = localStorage.language === 'ru' ? false : true;
    this.UPDATE_OVERLAY(false)
  },

  watch:{
    GETTERS_PROFILE(val) {
      this.station = val.data.profiles[0].station.filter(item => item.type === 'station')
      this.stations_count_big = this.station.length > 5
    },

    is_council_page(val){
        if(val){
          this.$router.push('/moderator-council')
        }
        else{
          this.$router.push('/moderator-tab-2')
        }
    },

    changeLanguage(newLang) {
/*
        if (newLang) {
          localStorage.token ? (this.LANGUAGE_SWITCH({
            id: this.GETTERS_LOGIN,
            language: 'en'
          }) , this.$i18n.locale = 'en') : (this.SET_APP_LANGUAGE('en'), this.$i18n.locale = 'en')

        }
        else {
          localStorage.token ? (this.LANGUAGE_SWITCH({
            id: this.GETTERS_LOGIN,
            language: 'ru'
          }), this.$i18n.locale = 'ru') : (this.SET_APP_LANGUAGE('ru'), this.$i18n.locale = 'ru')
        }
      */
    }
  },

  methods: {
    ...mapActions(['LANGUAGE_SWITCH', 'LOGOUT']),
    ...mapMutations([
      'SET_APP_LANGUAGE', 
      'SET_IS_LOGGED_IN', 
      'UPDATE_PARAMS_NAME_BS', 
      'UPDATE_OVERLAY',
      'SET_CURRENT_STATION',
    ]),

    login() {
      this.$router.push('login');
    },
    async goToPage(item, id) {

      this.SET_CURRENT_STATION(null);

      switch (item) {
        case 'logout':
          this.SET_IS_LOGGED_IN('');
          this.LOGOUT()
          break;
        case 'user':
          this.$route.name === 'PersonalData' ? window.location.href = '/user' : this.$router.push('/user')
          break;
        case 'moderator-2':
          this.$router.push('/moderator-tab-2')
          break;
        case 'expert-grid':
          this.$router.push('/expert-grid');
          break;
        case 'bs':
          this.$router.push('/bs/'+id);
          this.SET_CURRENT_STATION(id);
          break;
        case 'personal-data':
          this.$router.push('/personal-data');
          break;
        case 'Home':
          this.$router.push('/');
          break;
        case 'dashboard':
          this.$router.push('/dashboard');
          break;
        case 'synchrotron_calendar':
          this.$router.push('/synchrotron-calendar');
          break;
        case 'reactor_calendar':
          this.$router.push('/reactor-calendar');
          break;
        case 'privacy':
          this.$router.push('/privacy');
          break;
        case 'passes':
          this.$router.push('/passes');
          break;
        case 'invitations':
          this.$router.push('/invitations');
          break;          
        case 'references':
          this.$router.push('/references');
          break;
        case 'users':
          this.$router.push('/users');
          break;
        default:
          break;
      }
    },
  },
  computed: {
    ...mapGetters([
      'GETTERS_APP_LANGUAGE',
      'GETTERS_LOGIN',
      'GETTERS_NAME_USER',
      'GETTERS_AVATAR',
      'GETTERS_PROFILE',
      'GETTERS_HAVE_ROLE',
    ]),
    isLoggedIn() {
      return localStorage.isLoggedIn;
    },
  },
};
</script>
<style lang="scss">
  @import '../../pages/css/trello_board.scss';
  .ui-container {
    margin-top: 100px;
  }
</style>
<style>
  @import '../../pages/css/statusUser.css';

  .header-container{
    -webkit-box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03) !important;
    box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03) !important;
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
  }
  body{
    background: hsla(0,0%,100%,.45)
  }
  .right-buttons{
    margin-top: 0px;
  }
  a:visited {
    color: white;
    text-decoration: none;
  }
  .icon{
    border-radius: 50%;
    margin-right: 7px;
  }
  .header-container .logo{
    height: 25px;
    width: 20px !important;
    flex: none !important;
  }
  a {
    text-decoration: none;
  }
.header-title{
  margin-left: 10px;
  width: 100%;
}
  .left-buttons {
    display: flex;
    flex-direction: row;
    width: 210px;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
  }

  .middle-buttons {
    display: flex;
    flex-direction: row;
    width: 300px;
    height: 48px;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
  }

  .text-header{
    font-size: 0.8125rem;
  }
  #select.menu {
    outline: none;
    border: 2px solid #FFFFFF;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 0 5px;
    margin-right: 10px;
  }
  #select-auth.menu {
    outline: none;
    border: 2px solid #FFFFFF;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 0 5px;
    margin-right: 10px;
  }
.hidden{
  display: none;
}
.switch-moderator{
  min-width: 350px;
  margin-top: 23px;
}
.cc_btn{
  margin-top: 10px;
}
  .header {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    padding: 0;
    height: 48px;
  }
  .header .left-buttons {
    height: 100%;
  }

  .right-buttons {
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
  }
 .v-btn.v-btn--contained.theme--dark.v-size--default{
    border-color: white;
  }/*
  .v-sheet.v-sheet--tile.theme--dark.v-toolbar.v-app-bar.v-app-bar--fixed{
    height: 43px!important;
  }
  .v-toolbar__content.v-toolbar__extension{
    height: 43px!important;
  }*/
  .header-container {
    z-index: 99999;
    height: 48px !important;
    min-height: 48px;
    background-color: #022b61!important;
    -webkit-box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03) !important;
    box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03) !important;
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
  }
  .header-container .v-toolbar__content {
    height: 100% !important;
  }
  .btn-group-header{
    margin-left: 7px;
    outline: none;
  }
  .v-list-item__title {
    font-size: 13px;
    line-height: 15px;
  }

  @media screen and (max-width:660px) {
    .header {
      height: 100% !important;

    }
    .header-container {
      height: auto !important;
    }
  }
</style>
